module.exports = __webpack_public_path__ + "img/home-outline.4f015a9a.svg";